export default __webpack_public_path__ + "static/rovo-elevation-light-5ee4cc53d88894d19ee89e4931403a5626075021fb0220ca9c20661f9e1eaff2.png";